import { t } from "i18next";
import { calendarDaysUntil } from "@/utils/date";
var TASK_INTENT = {
  done: "success",
  overdue: "urgent",
  soon: "attention",
  upcoming: "base"
};

/** Computes the number of days until (or since) the due date and a human-readable label. */
export function getDaysUntilDue(remind_after) {
  var _calendarDaysUntil;
  var daysRemaining = (_calendarDaysUntil = calendarDaysUntil(remind_after)) !== null && _calendarDaysUntil !== void 0 ? _calendarDaysUntil : 0;
  if (daysRemaining === 0) return {
    text: t("due_today"),
    daysRemaining: daysRemaining
  };
  if (daysRemaining === 1) return {
    text: t("due_tomorrow"),
    daysRemaining: daysRemaining
  };
  if (daysRemaining < 0) return {
    text: t("overdue_days", {
      days: Math.abs(daysRemaining)
    }),
    daysRemaining: daysRemaining
  };
  return {
    text: t("due_in_days", {
      days: daysRemaining
    }),
    daysRemaining: daysRemaining
  };
}

/** Derives the four-state display status of a reminder. */
export function getTaskStatus(reminder) {
  if (reminder.resolved) return "done";
  var _getDaysUntilDue = getDaysUntilDue(reminder.remind_after),
    daysRemaining = _getDaysUntilDue.daysRemaining;
  if (daysRemaining < 0) return "overdue";
  if (daysRemaining <= 7) return "soon";
  return "upcoming";
}

/** Returns the semantic intent and badge label for a reminder's current status. */
export function getTaskDisplayProps(reminder) {
  var status = getTaskStatus(reminder);
  var intent = TASK_INTENT[status];
  if (status === "done") return {
    intent: intent,
    label: t("key.task_status.done")
  };
  return {
    intent: intent,
    label: getDaysUntilDue(reminder.remind_after).text
  };
}

/** Counts the total number of IDs across all linked resource types. */
export function countLinkedResources(linkedResources) {
  return Object.values(linkedResources).reduce(function (sum, ids) {
    return Array.isArray(ids) ? sum + ids.length : sum;
  }, 0);
}